import { render, staticRenderFns } from "./solution_card.vue?vue&type=template&id=c05cb8d8&"
import script from "./solution_card.vue?vue&type=script&lang=js&"
export * from "./solution_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports